export const LIGHTBOX_CSS = `
  .sc-lightbox {
    position: fixed; inset: 0; z-index: 9999;
    background: rgba(4,12,24,0.96);
    display: flex; align-items: center; justify-content: center;
    backdrop-filter: blur(4px);
  }
  .sc-lightbox__close {
    position: absolute; top: 20px; right: 24px;
    background: rgba(255,255,255,0.1);
    border: 1px solid rgba(255,255,255,0.15);
    color: white; width: 40px; height: 40px;
    display: flex; align-items: center; justify-content: center;
    cursor: pointer; transition: background 0.2s;
    z-index: 2;
  }
  .sc-lightbox__close:hover { background: rgba(255,255,255,0.2); }
  .sc-lightbox__stage {
    max-width: 90vw; max-height: 90vh;
    display: flex; flex-direction: column; align-items: center; gap: 12px;
  }
  .sc-lightbox__img {
    max-width: 90vw; max-height: 82vh;
    object-fit: contain; display: block;
    box-shadow: 0 24px 80px rgba(0,0,0,0.6);
  }
  .sc-lightbox__counter {
    font-family: var(--font-sans); font-size: 11px;
    letter-spacing: 0.12em; text-transform: uppercase;
    color: rgba(255,255,255,0.45);
  }
  .sc-lightbox__nav {
    position: absolute; top: 50%; transform: translateY(-50%);
    background: rgba(255,255,255,0.08);
    border: 1px solid rgba(255,255,255,0.12);
    color: white; width: 52px; height: 52px;
    display: flex; align-items: center; justify-content: center;
    cursor: pointer; transition: background 0.2s;
    z-index: 2;
  }
  .sc-lightbox__nav:hover { background: rgba(255,255,255,0.18); }
  .sc-lightbox__nav--prev { left: 24px; }
  .sc-lightbox__nav--next { right: 24px; }
`
